export const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const DAY_NAMES = { Mon: "Monday", Tue: "Tuesday", Wed: "Wednesday", Thu: "Thursday", Fri: "Friday", Sat: "Saturday", Sun: "Sunday" };

export const DAY_NAMES_AR = { Mon: "الاثنين", Tue: "الثلاثاء", Wed: "الأربعاء", Thu: "الخميس", Fri: "الجمعة", Sat: "السبت", Sun: "الأحد" };
const DAY_SHORT_AR = { Mon: "إثن", Tue: "ثلا", Wed: "أرب", Thu: "خمي", Fri: "جمع", Sat: "سبت", Sun: "أحد" };

export const dayName = (d, lang) => (lang === "ar" ? DAY_NAMES_AR[d] : DAY_NAMES[d]) || d;
export const dayShort = (d, lang) => (lang === "ar" ? DAY_SHORT_AR[d] : d) || d;

export const COLORS = {
  cyan: "#00F0FF",
  magenta: "#FF2D7B",
  lime: "#CCFF00",
  amber: "#FFB800",
  violet: "#A78BFA",
  orange: "#FF7A1A",
  sky: "#38BDF8",
};

export const colorOf = (c) => COLORS[c] || COLORS.cyan;
export const GOLD = "#D4AF37";

export const todayKey = () => DAYS[(new Date().getDay() + 6) % 7];

export const toMin = (t) => {
  if (!t || !t.includes(":")) return null;
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m;
};

export const fmtTime = (t, withMeridiem = true, lang = "en") => {
  const m = toMin(t);
  if (m === null) return "";
  const h = Math.floor(m / 60);
  const mm = String(m % 60).padStart(2, "0");
  const h12 = ((h + 11) % 12) + 1;
  const mer = lang === "ar" ? (h >= 12 ? "م" : "ص") : h >= 12 ? "PM" : "AM";
  return withMeridiem ? `${h12}:${mm} ${mer}` : `${h12}:${mm}`;
};

export const fmtRange = (s, lang = "en") => {
  if (!s?.start) return lang === "ar" ? "الوقت يُحدد لاحقاً" : "Time TBA";
  if (!s.end) return fmtTime(s.start, true, lang);
  const same = (toMin(s.start) >= 720) === (toMin(s.end) >= 720);
  return `${fmtTime(s.start, !same, lang)}–${fmtTime(s.end, true, lang)}`;
};

export const waLink = (contact, text, lang = "en") =>
  `https://wa.me/${(contact?.whatsapp || "").replace(/\D/g, "")}?text=${encodeURIComponent(text || (lang === "ar" && contact?.trial_message_ar) || contact?.trial_message || "")}`;

export const DEFAULT_CONTENT = {
  classes: [
    { id: "junior-jammers", title: "Junior Jammers", tag: "Ages 4–8", tag_ar: "الأعمار 4–8", style: "Hip-Hop & Bollywood", style_ar: "هيب هوب وبوليوود", program: "dillusions", color: "cyan", fee: "", image: "/img/group.jpg",
      sessions: [{ day: "Sat", start: "17:00", end: "18:00" }, { day: "Mon", start: "18:00", end: "19:00" }] },
    { id: "little-legends", title: "Little Legends", tag: "Ages 9–12", tag_ar: "الأعمار 9–12", style: "Hip-Hop & Bollywood", style_ar: "هيب هوب وبوليوود", program: "dillusions", color: "magenta", fee: "", image: "/img/hiphop.jpg",
      sessions: [{ day: "Sat", start: "18:00", end: "19:00" }, { day: "Tue", start: "18:00", end: "19:00" }] },
    { id: "teens-adults", title: "Teens & Adults", tag: "Ages 13+", tag_ar: "الأعمار +13", style: "Hip-Hop & Bollywood", style_ar: "هيب هوب وبوليوود", program: "dillusions", color: "lime", fee: "", image: "/img/stage.jpg",
      sessions: [{ day: "Sat", start: "19:00", end: "20:30" }, { day: "Mon", start: "19:00", end: "20:30" }] },
    { id: "mishal", title: "Mishal", title_ar: "مشعل", tag: "Instructor", tag_ar: "حصة متخصصة", style: "Hip-Hop", style_ar: "هيب هوب", program: "specialty", color: "violet", fee: "Standard Rate", fee_ar: "السعر القياسي", image: "/img/hiphop.jpg",
      sessions: [{ day: "Wed", start: "", end: "" }] },
    { id: "ria", title: "Ria", title_ar: "ريا", tag: "Instructor", tag_ar: "حصة متخصصة", style: "Bollywood", style_ar: "بوليوود", program: "specialty", color: "amber", fee: "30 KD / month", fee_ar: "30 د.ك / شهرياً", image: "/img/bollywood.jpg",
      sessions: [{ day: "Thu", start: "19:00", end: "20:00" }] },
    { id: "vibin", title: "Vibin (VJ)", title_ar: "فيبن (VJ)", tag: "Instructor", tag_ar: "حصة متخصصة", style: "Urban Hip-Hop", style_ar: "أوربن هيب هوب", program: "specialty", color: "orange", fee: "30 KD / month", fee_ar: "30 د.ك / شهرياً", image: "/img/group.jpg",
      sessions: [{ day: "Mon", start: "19:00", end: "20:30" }] },
    { id: "awash", title: "Awash", title_ar: "أواش", tag: "Instructor", tag_ar: "حصة متخصصة", style: "Afrobeat", style_ar: "أفروبيت", program: "specialty", color: "sky", fee: "Standard Rate", fee_ar: "السعر القياسي", image: "/img/solo.jpg", sessions: [] },
  ],
  pricing: { currency: "KD", monthly_fee: 20, min_classes: 8, full_threshold: 5, reduced_fee: 10, sibling_discount: 5, free_trial: 1, note: "Free trial applies to all Dillusions batches.",
    currency_ar: "د.ك", note_ar: "الحصة التجريبية المجانية متاحة لجميع مجموعات Dillusions." },
  contact: { phone: "+965 92288093", whatsapp: "96592288093", instagram: "https://www.instagram.com/mrva_productions/", location: "Al Salam Mall, Salmiya",
    map_url: "https://www.google.com/maps/search/?api=1&query=Al+Salam+Mall+Salmiya", trial_message: "Hi MRVA Productions! I'd like to book a free trial class.",
    location_ar: "السلام مول، السالمية", trial_message_ar: "مرحباً MRVA Productions! أود حجز حصة تجريبية مجانية." },
  texts: {},
  images: { hero: "/img/hero.jpg", programs: "/img/group.jpg" },
  sections: [{ id: "marquee", visible: true }, { id: "programs", visible: true }, { id: "rates", visible: true }, { id: "specialty", visible: true }, { id: "contact", visible: true }],
  theme: { accent: "#CCFF00", accent2: "#FF2D7B", logo: "" },
  announcement: { enabled: false, text: "", text_ar: "", link_label: "", link_label_ar: "", link_url: "", color: "accent" },
};

export const feeAmount = (cls) => {
  const m = (cls?.fee || "").match(/\d+(\.\d+)?/);
  return m ? Number(m[0]) : null;
};

export const SECTION_IDS = ["marquee", "programs", "rates", "specialty", "contact"];
export const SECTION_LABELS = { marquee: "Scrolling banner", programs: "Dillusions program", rates: "Rates & calculator", specialty: "Specialty classes", contact: "Contact & booking" };

const normSections = (list) => {
  const valid = (Array.isArray(list) ? list : []).filter((s) => SECTION_IDS.includes(s?.id));
  const missing = SECTION_IDS.filter((id) => !valid.some((s) => s.id === id)).map((id) => ({ id, visible: true }));
  return [...valid.map((s) => ({ id: s.id, visible: s.visible !== false })), ...missing];
};

export const normalize = (d) => ({
  classes: Array.isArray(d?.classes) ? d.classes.map((c) => ({ ...c, sessions: Array.isArray(c?.sessions) ? c.sessions : [] })) : DEFAULT_CONTENT.classes,
  pricing: { ...DEFAULT_CONTENT.pricing, ...(d?.pricing || {}) },
  contact: { ...DEFAULT_CONTENT.contact, ...(d?.contact || {}) },
  texts: d?.texts && typeof d.texts === "object" ? d.texts : {},
  images: { ...DEFAULT_CONTENT.images, ...Object.fromEntries(Object.entries(d?.images || {}).filter(([, v]) => v)) },
  sections: normSections(d?.sections),
  theme: { ...DEFAULT_CONTENT.theme, ...Object.fromEntries(Object.entries(d?.theme || {}).filter(([, v]) => v)) },
  announcement: { ...DEFAULT_CONTENT.announcement, ...(d?.announcement || {}) },
  updated_at: d?.updated_at ?? null,
});

const hexRgb = (hex) => {
  const h = (hex || "").replace("#", "");
  const full = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
  const n = parseInt(full, 16);
  return Number.isNaN(n) || full.length !== 6 ? null : [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};

const rgbHsl = ([r, g, b]) => {
  const [R, G, B] = [r / 255, g / 255, b / 255];
  const max = Math.max(R, G, B), min = Math.min(R, G, B), l = (max + min) / 2, d = max - min;
  if (!d) return `0 0% ${Math.round(l * 100)}%`;
  const s = d / (1 - Math.abs(2 * l - 1));
  const h = max === R ? ((G - B) / d) % 6 : max === G ? (B - R) / d + 2 : (R - G) / d + 4;
  return `${Math.round((h * 60 + 360) % 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
};

export const applyTheme = (theme) => {
  const root = document.documentElement.style;
  const a = hexRgb(theme?.accent) || [204, 255, 0];
  const b = hexRgb(theme?.accent2) || [255, 45, 123];
  const lum = (0.299 * a[0] + 0.587 * a[1] + 0.114 * a[2]) / 255;
  root.setProperty("--accent-rgb", a.join(" "));
  root.setProperty("--brand", `rgb(${a.join(",")})`);
  root.setProperty("--accent-hsl", rgbHsl(a));
  root.setProperty("--on-accent-rgb", lum > 0.6 ? "0 0 0" : "255 255 255");
  root.setProperty("--accent2-rgb", b.join(" "));
  root.setProperty("--accent2", `rgb(${b.join(",")})`);
};

// Flatten classes into session entries for a given day
export const sessionsForDay = (classes, day) =>
  classes
    .flatMap((c) => c.sessions.filter((s) => s.day === day).map((s) => ({ cls: c, s })))
    .sort((a, b) => (toMin(a.s.start) ?? 9999) - (toMin(b.s.start) ?? 9999));
